// extracted by mini-css-extract-plugin
export default {"countdown":"ticketCountdown__countdown__zRKW2","countdownVisible":"ticketCountdown__countdownVisible__eWFEZ ticketCountdown__countdown__zRKW2","time":"ticketCountdown__time__I5FjG"};